<template>
  <div class="home">
    <div class="grey-card">
      <!-- 走马灯 -->
      <el-carousel
        :interval="5000"
        type="card"
        :height="carHeight + 'px'"
        class="carousel"
      >
        <el-carousel-item v-for="item in carList" :key="item.id">
          <img ref="carHeight" :src="item.idView" class="car" />
        </el-carousel-item>
      </el-carousel>
    </div>
    <div class="white-card">
      <!-- 介绍 -->
      <div class="intro card">
      
        <div class="title">{{ $t('home.title1') }}</div>
        <div class="title">{{ $t('home.title11') }}</div>

        <div class="line"></div>
        <div class="content">
         <p>
            {{ $t('home.content3') }}
          </p>
          <p>
            {{ $t('home.content4') }}
          </p>
<!--             <p>
            {{ $t('home.content5') }}
          </p>
         <p>
            {{ $t('home.content6') }}
          </p>
-->
        </div>

        <div class="title">{{ $t('home.title') }}</div>
        <div class="line"></div>
        <div class="content">
           <p>
            {{ $t('home.content1') }}
          </p>
          <p>
            {{ $t('home.content2') }}
          </p>
          <!-- <p>
            {{ $t('home.content12') }}
          </p>
             <p>
            {{ $t('home.content13') }}
          </p>  -->
        </div>
      </div>
    </div>
    <div class="grey-card">
      <!-- 时间节点 -->
      <!-- <div class="date card">
        <p class="title">{{ $t('home.title2') }}</p>
        <p class="line"></p>
        <el-steps align-center class="steps">
          <el-step
            status="process"
            :title="$t('home.date1')"
            :description="$t('home.desc1')"
            icon="el-icon-document"
          ></el-step>
          <el-step
            status="process"
            :title="$t('home.date2')"
            :description="$t('home.desc2')"
            icon="el-icon-message-solid"
          ></el-step>
          <el-step
            status="finish"
            :title="$t('home.date3')"
            :description="$t('home.desc3')"
            icon="el-icon-s-check"
          ></el-step>
        </el-steps>
      </div> -->
    </div>
  </div>
</template>

<style lang="less">
@cyan: #176998;
.home {
  .carousel {
    .el-carousel__item {
      .car {
        width: 100%;
      }
    }
  }
  .date {
    .steps {
      padding: 20px;
      .el-step__icon {
        background-color: #f7f7f7;
      }
      .el-step__title {
        font-size: 28px;
      }
      .el-step__description {
        margin-top: 10px;
        font-size: 18px;
      }
    }
  }
}
</style>

<script>
export default {
  name: 'Home',
  data() {
    return {
      carHeight:
        document.body.clientWidth > 1200
          ? (document.body.clientWidth * 9) / 32
          : 337.5,
      carList: [
        {
          id: 0,
          name: '三坊七巷',
          idView: require('./../assets/img/1.jpg'),
        },
        {
          id: 1,
          name: '鼓山风景区',
          idView: require('./../assets/img/2.jpg'),
        },
        {
          id: 2,
          name: '福州国家森林公园',
          idView: require('./../assets/img/3.jpg'),
        },
        {
          id: 3,
          name: '西禅寺',
          idView: require('./../assets/img/4.jpg'),
        },
        {
          id: 4,
          name: '平潭岛',
          idView: require('./../assets/img/5.jpg'),
        },
        {
          id: 5,
          name: '福州美食',
          idView: require('./../assets/img/6.jpg'),
        },
      ],
    };
  },
};
</script>
